import { useMediaQuery } from "@mui/material"
import DerivativesTalkWeb from "./DerivativesTalkWeb"
import DerivativesTalkMob from "./DerivativesTalkMob"
export default function Equity() {
    const isSmallScreen = useMediaQuery("(max-width:800px)");
    return isSmallScreen ? <DerivativesTalkMob /> : <DerivativesTalkWeb />;

}